import { Component, EventEmitter, Output } from "@angular/core";

@Component({
    selector: "app-button-clave-unica",
    templateUrl: 'button-clave-unica.component.html',
    styleUrls: ['button-clave-unica.component.scss']

})
export class AppButtonClaveUnica {
    @Output() login = new EventEmitter();
    
    handlerClick(){
        this.login.emit()
    }

}